<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white" v-if="!display_confirm_send">
            <div v-if="exist">
              <v-alert>Accès refusé. Vous nous avez déjà fait part de votre choix.
                <span v-if="report_request.decision == 'conserver'"> Votre inscription est conservé pour l'événement à
                  sa date de report.</span>
                <span v-else-if="report_request.decision == 'rembourser'"> Votre inscription sera remboursée.</span>
                <span v-else-if="report_request.decision == 'donner'"> Vous avez fait don des frais d'inscription à
                  l'organisateur.</span>
              </v-alert>
              <div class="mt-3 d-flex justify-center">
                <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à l'accueil</v-btn></router-link>
              </div>
            </div>
            <div v-if="has_expired">
              <v-alert>Accès refusé. La date limite pour faire votre choix est dépassée. </v-alert>
              <div class="mt-3 d-flex justify-center">
                <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à l'accueil</v-btn></router-link>
              </div>
            </div>

            <div v-else-if="!exist && !has_expired">
              <v-row class="my-3">
                <v-col md="4"></v-col>
                <v-col cols="12" md="4">
                  <p>
                    Bonjour <span v-if="infos.prenom">{{ infos.prenom }}</span>,
                  </p>
                  <p>Suite au report de l'événement, vous êtes invité à faire le choix de:</p>
                  <v-select :items="items" v-model="report_request.decision"></v-select>
                  <v-alert v-if="report_request.decision == 'conserver'" border="start" border-color="primary-dark">
                    Votre inscription sera conservée et vous pourrez participer à l'événement à sa date de report.
                  </v-alert>
                  <v-alert v-else-if="report_request.decision == 'rembourser'" border="start"
                    border-color="primary-dark"> Votre inscription sera remboursée et vous ne serez plus inscrit à
                    l'événement à sa date de report. </v-alert>
                  <p v-if="date_max != ''" class="mt-3">
                    <v-icon icon="mdi-alert" color="primary"></v-icon> Vous avez jusqu'au {{
                      $moment(date_max).format("DD/MM/YYYY") }} pour nous faire part de votre choix. Passée cette date,
                    votre inscription sera conservée.
                  </p>
                  <v-btn color="primary-dark" class="mt-3" @click="display_confirm_dialog = true"><span
                      v-if="report_request.decision == 'conserver'">Je conserve mon inscription</span><span
                      v-else-if="report_request.decision == 'rembourser'">Je demande le remboursement</span></v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-else class="pa-2 rounded elevation-1 bg-white">
            <v-row class="my-3">
              <v-col md="4"></v-col>
              <v-col cols="12" md="4">
                <v-alert border="start" border-color="primary-dark">Votre choix a bien été pris en compte.</v-alert>
                <div class="mt-3 d-flex justify-center">
                  <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à
                      l'accueil</v-btn></router-link>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="display_confirm_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Etes-vous sûr?</div>
          <p>Une fois votre choix fait, vous ne pourrez plus modifier votre réponse.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="display_confirm_dialog = false">Annuler</v-btn>
          <v-btn color="primary-dark" variant="tonal" @click="sendRequest">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  components: {},
  data() {
    return {
      display_confirm_dialog: false,
      display_confirm_send: false,
      crypted_id: "",
      exist: false,
      report_request: {
        id_module: "",
        decision: "conserver",
        token: "",
      },
      date_max: "",
      has_expired: false,
      infos: {},

      items: [
        { title: "Conserver mon inscription", value: "conserver" },
        { title: "Demander le remboursement", value: "rembourser" },
      ],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async sendRequest() {
      this.report_request.token = this.crypted_id;
      let res = await axios.post("/report_request/post.php", this.report_request);
      if (res.data.error) {
        console.log(res.data.error);
      } else {
        this.display_confirm_dialog = false;
        this.display_confirm_send = true;
      }
    },
    init() {

      this.report_request.id_module = this.mainStore.module.id;
      const choix_report_date_max = this.mainStore.module.choix_report_date_max && this.mainStore.module.choix_report_date_max != "";
      if (choix_report_date_max) {
        this.date_max = this.mainStore.module.choix_report_date_max;
        if (this.$moment().isAfter(this.date_max)) {
          this.has_expired = true;
        }
      }
    },
    async get_inscription_infos() {
      let res = await axios.get("/report_request/get_infos.php?token=" + this.crypted_id);
      if (res.data.error) {
        console.log(res.data.error);
      } else {
        this.infos = res.data;
      }
    },
    async get_report_request() {
      let res = await axios.get("/report_request/get.php?token=" + this.crypted_id);
      if (res.data.error) {
        console.log(res.data.error);

        return await false;
      } else {
        this.report_request = res.data;
        this.exist = true;
        return await true;
      }
    },
  },
  async created() {
    if (!this.$route.query.req) {
      this.$router.push({ name: "Home" });
    }
    this.crypted_id = this.$route.query.req;
    this.init();
    await this.get_report_request();
    await this.get_inscription_infos();
  },
};
</script>

<style lang="scss" scoped></style>